export const advancementsKey = Object.freeze({
  ADVENTURES: 'adventures',
  RANKS: 'ranks',
  MERIT_BADGES: 'meritBadges',
  AWARDS: 'awards',
  LEADERSHIP: 'leadership',
});
